module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showPublishButton || showAttachButton) { ;
__p += '\n    <div class="buttons-container">\n        ';
 if (showPublishButton) { ;
__p += '\n            <button id="publish-channels" class="btn pull-right ladda-button';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-spinner-size="28" data-style="expand-right"></button>\n        ';
 } ;
__p += '\n        ';
 if (showAttachButton) { ;
__p += '\n            <button id="attach-channels" class="attach-button btn btn-grey pull-right ';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '" ';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>Attach</button>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n\n';
 if (showAttachHeader) { ;
__p += '\n    <h4 class="attach-header">' +
__e( attachHeader ) +
' <span class="count thin">(' +
__e( itemCount ) +
')</span></h4>\n';
 } ;
__p += '\n\n\n<div class="channels-header">\n    <span class="head-slot-col slot-col">Slot</span>\n    <span class="live-now-col channel-numeric-icon" data-icon-number="1">Live</span>\n    <span class="live-next-col channel-numeric-icon" data-icon-number="2">Scheduled</span>\n    <span class="live-date-col">Scheduled Date</span>\n    <span class="action-column slot-options-col"></span>\n</div>\n';
 if (allowedToPublish && showCreateSlotField) { ;
__p += '\n    <div class="slot-divider"><td colspan="5"></div>\n    <div class="create-new-slot">&#43; <span id="create-new-slot">Create New Slot';
 if (showCreateSlotInProjectLabel) { ;
__p += ' In Project';
 } ;
__p += '</span></div>\n    <div class="slot-divider no-border"><td colspan="5"></div>\n';
 } ;
__p += '\n\n<div class="content collection channel-items"></div>\n';
 if (showAttachActions) { ;
__p += '\n    <div class="actions">\n        <button class="btn-ok-attach attach-button btn btn-primary pull-right ladda-button';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-spinner-size="28" data-style="expand-right">Attach</button>\n        <button class="btn-cancel-attach btn btn-secondary pull-right">Cancel</button>\n    </div>\n';
 } ;
__p += '\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/channelSetup/ChannelSetupManualView.tpl
// module id = 2845
// module chunks = 0